import {
  Component,
  ChangeDetectionStrategy,
  ElementRef,
  Host,
  Renderer2,
  OnInit,
  HostBinding,
} from '@angular/core';

import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

import { GasDynamicBaseComponent } from '../../../core/gas-dynamic-base/gas-dynamic-base.component';
import { GasClickOutsideDirective } from '../../../utils/click-outside-directive/gas-click-outside.directive';
import { GasObjectFilterPipe } from '../../../utils/gas-object-filter-pipe/gas-object-filter.pipe';
import { GasAutocompleteComponent } from '../wrapper/gas-autocomplete.component';
import { GasAutocompleteOptions } from '../gas-autocomplete.interface';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

const GROW_COEFFICIENT = 0.25;

/**
 * todo: доработать в дропдауне следующие возможности:
 * 1 - ходить стрелками по доступным опциям
 * 2 - состояние активности для выбранного элемента
 */
@UntilDestroy()
@Component({
  selector: 'gas-autocomplete-dropdown',
  templateUrl: './gas-autocomplete-dropdown.component.html',
  styleUrls: ['./gas-autocomplete-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    GasClickOutsideDirective,
    GasObjectFilterPipe,
  ],
})
export class GasAutocompleteDropdownComponent extends GasDynamicBaseComponent<string | number> implements OnInit {
  @HostBinding('style.width.px')
  public get dropdownWidth(): number {
    const selectElement: HTMLElement = this.gasAutocomplete.elementRef.nativeElement;

    return this.gasAutocomplete.dropdownSameWidth
      ? selectElement.clientWidth
      : selectElement.clientWidth + (selectElement.clientWidth * GROW_COEFFICIENT);
  }

  @HostBinding('style.maxWidth.px')
  public get dropdownMaxWidth(): number {
    return this.gasAutocomplete.dropdownSameWidth
      ? this.gasAutocomplete.elementRef.nativeElement.clientWidth
      : 590;
  }

  @HostBinding('style.minWidth.px')
  public get dropdownMinWidth(): number {
    return this.gasAutocomplete.dropdownSameWidth
      ? this.gasAutocomplete.elementRef.nativeElement.clientWidth
      : 200;
  }

  public gasAutocomplete: GasAutocompleteComponent;

  public filterSubject$ = new BehaviorSubject<string>('');

  public filterOptions$: Observable<GasAutocompleteOptions[]> = this.filterSubject$.pipe(
    map((value: string) => {
      if (!this.defaulFilters) {
        return this.options;
      }
      //todo: фильтрация должна быть настраиваемая
      return value.trim() || this.autocompleteTitle.trim() ?
        this.gasObjectFilterPipe.transform(this.options, 'title', value || this.autocompleteTitle) :
        this.options;
    }),
  );

  public get options(): GasAutocompleteOptions[] {
    return this.gasAutocomplete.options;
  }

  //todo: value контрола не обязательно должно быть объектом и иметь поле title
  public get autocompleteTitle(): string {
    return this.gasAutocomplete.control?.value?.title || '';
  }

  public get defaulFilters(): boolean {
    return this.gasAutocomplete?.defaultFilter;
  }

  public get loading$(): Observable<boolean> {
    return this.gasAutocomplete.loading$.asObservable();
  }

  constructor(
    public el: ElementRef,
    @Host() public gasClickOutsideDirective: GasClickOutsideDirective,
    public renderer: Renderer2,
    private gasObjectFilterPipe: GasObjectFilterPipe<any>,
  ) {
    super(el, gasClickOutsideDirective, renderer);
  }

  public ngOnInit(): void {
    this.gasAutocomplete.nativeValueSubject$.pipe(
      untilDestroyed(this),
    ).subscribe((value: string) => this.filterSubject$.next(value));
  }

  public selectOption(option: any): void {
    this.close(null);
    //todo: в value не обязательно должен записываться весь объект
    this.gasAutocomplete.control?.patchValue(option);
  }
}
